import "./contact.css";

import React from "react";

import { CONTACT, CONTACT_DETAILS } from "../../data/content";
import { postRequest } from "../../utils/apiHandlers";
import PageBanner from "../general/PageBanner";
import PageMeta from "../general/PageMeta";

const EMPTY = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
  website: "", //Honeypot
};

const Field = ({ label, isRequired = false, children }) => (
  <label className={"contact-field"}>
    <span className={"contact-label"}>
      {label}
      {isRequired ? <span aria-hidden={"true"}>*</span> : null}
    </span>
    {children}
  </label>
);

const Contact = () => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [sentTo, setSentTo] = React.useState(null);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendContactMessage", form);
      setSentTo(form.firstName);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  return (
    <React.Fragment>
      <PageMeta
        title={"Contact Us"}
        description={"Contact Salgado's Quality Foods in Boksburg - call +27 11 397 4685 or email info@salgados.co.za. Interested in stocking Salgado's products? We have national representation and distribution."}
      />
      <PageBanner
        title={CONTACT.TITLE}
        subtitle={CONTACT.SUBTITLE}
        color={"var(--terracotta)"}
        divider={"wave"}
        dividerColor={"var(--terracotta)"}
      />
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--terracotta)" }}
      />

      <section className={"contact"}>
        <div className={"contact-inner container"}>
          <div className={"contact-details"}>
            <h2 className={"contact-heading"}>contact details.</h2>
            <p>
              Tel: <a href={CONTACT_DETAILS.PHONE.link}>{CONTACT_DETAILS.PHONE.label}</a>
              <br />
              Email: <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            </p>

            <h2 className={"contact-heading"}>BUSINESS HOURS.</h2>
            <p>
              {CONTACT.HOURS.map((line) => (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>

            <h2 className={"contact-heading"}>DISTRIBUTION &amp; TRADE.</h2>
            <p>{CONTACT.TRADE}</p>

            <h2 className={"contact-heading"}>FOLLOW US</h2>
            <p>
              <a
                href={CONTACT_DETAILS.FACEBOOK_LINK}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                Facebook
              </a>
              {" | "}
              <a
                href={CONTACT_DETAILS.INSTAGRAM_LINK}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                Instagram
              </a>
            </p>
          </div>

          <div className={"contact-card"}>
            <h2 className={"contact-card-title"}>{CONTACT.FORM_TITLE}</h2>

            {sentTo !== null ? (
              <div
                className={"contact-success"}
                role={"status"}
              >
                <p>Thanks for your message{sentTo ? `, ${sentTo}` : ""}! Our team will get back to you.</p>
                <button
                  type={"button"}
                  className={"contact-submit"}
                  onClick={() => setSentTo(null)}
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form
                className={"contact-form"}
                onSubmit={onSubmit}
              >
                <Field label={"First name"}>
                  <input
                    type={"text"}
                    value={form.firstName}
                    onChange={update("firstName")}
                    maxLength={100}
                    autoComplete={"given-name"}
                    placeholder={"First name"}
                  />
                </Field>
                <Field label={"Last name"}>
                  <input
                    type={"text"}
                    value={form.lastName}
                    onChange={update("lastName")}
                    maxLength={100}
                    autoComplete={"family-name"}
                    placeholder={"Last name"}
                  />
                </Field>
                <Field
                  label={"Email"}
                  isRequired
                >
                  <input
                    type={"email"}
                    value={form.email}
                    onChange={update("email")}
                    required
                    maxLength={200}
                    autoComplete={"email"}
                    placeholder={"Email"}
                  />
                </Field>
                <Field
                  label={"Message"}
                  isRequired
                >
                  <textarea
                    value={form.message}
                    onChange={update("message")}
                    required
                    maxLength={5000}
                    rows={4}
                    placeholder={"Message"}
                  />
                </Field>
                <label
                  className={"contact-honeypot"}
                  aria-hidden={"true"}
                >
                  Website
                  <input
                    type={"text"}
                    value={form.website}
                    onChange={update("website")}
                    tabIndex={-1}
                    autoComplete={"off"}
                  />
                </label>

                {errorText ? (
                  <p
                    className={"contact-error"}
                    role={"alert"}
                  >
                    {errorText}
                  </p>
                ) : null}

                <button
                  type={"submit"}
                  className={"contact-submit"}
                  disabled={isSending}
                >
                  {isSending ? "Sending..." : "Submit"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
      <div
        className={"stripe-band"}
        style={{ "--band": "var(--terracotta)" }}
      />
    </React.Fragment>
  );
};

export default Contact;
